<template>
  <div>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Padding Top</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="top-slider"
          v-model="top"
          :interval="1"
          adsorb
          tooltip="none"
          :duration="0"
          :data="topPaddingClasses"
        ></vue-slider>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Padding Bottom</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="bottom-slider"
          v-model="bottom"
          :interval="1"
          adsorb
          tooltip="none"
          :duration="0"
          :data="bottomPaddingClasses"
        ></vue-slider>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Padding Left</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="left-slider"
          v-model="left"
          :interval="1"
          adsorb
          tooltip="none"
          :duration="0"
          :data="leftPaddingClasses"
        ></vue-slider>
      </div>
    </li>
    <li class="wf-flex wf-flex-wrap wf-flex-row wf-w-full wf-py-2">
      <span class="wf-w-1/2 wf-font-light wf-lowercase wf-text-gray-500 wf-text-xs wf-tracking-wide">Padding Right</span>
      <div class="wf-w-1/2">
        <vue-slider
          ref="right-slider"
          v-model="right"
          :interval="1"
          adsorb
          tooltip="none"
          :duration="0"
          :data="rightPaddingClasses"
        ></vue-slider>
      </div>
    </li>
  </div>
</template>

<script>
  import _ from 'lodash'
  import {PaddingTopClasses, PaddingBottomClasses, PaddingLeftClasses, PaddingRightClasses} from '../classes/PaddingClasses'
  import MenuStyleProperty from '../contracts/MenuStyleProperty'
  export default MenuStyleProperty.extend({
    computed: {
      leftPaddingClasses() {
        return Object.keys(PaddingLeftClasses)
      },
      rightPaddingClasses() {
        return Object.keys(PaddingRightClasses)
      },
      topPaddingClasses() {
        return Object.keys(PaddingTopClasses)
      },
      bottomPaddingClasses() {
        return Object.keys(PaddingBottomClasses)
      },
      top: {
        get() {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.topPaddingClasses.includes(elementClass.value))
          if (! currentPadding) {
            currentPadding = {property: 'PaddingTop', value: 'PADDING_TOP_XS', touched: false}
            this.addToArray(this.module, [currentPadding], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentPadding.value
        },

        set: _.debounce(function (value) {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.topPaddingClasses.includes(elementClass.value))
          value = {property: 'PaddingTop', value: value, touched: currentPadding.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      bottom: {
        get() {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.bottomPaddingClasses.includes(elementClass.value))
          if (! currentPadding) {
            currentPadding = {property: 'PaddingBottom', value: 'PADDING_BOTTOM_XS', touched: false}
            this.addToArray(this.module, [currentPadding], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentPadding.value
        },

        set: _.debounce(function (value) {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.bottomPaddingClasses.includes(elementClass.value))
          value = {property: 'PaddingBottom', value: value, touched: currentPadding.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      left: {
        get() {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.leftPaddingClasses.includes(elementClass.value))
          if (! currentPadding) {
            currentPadding = {property: 'PaddingLeft', value: 'PADDING_LEFT_NONE', touched: false}
            this.addToArray(this.module, [currentPadding], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentPadding.value
        },

        set: _.debounce(function (value) {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.leftPaddingClasses.includes(elementClass.value))
          value = {property: 'PaddingLeft', value: value, touched: currentPadding.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
      right: {
        get() {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.rightPaddingClasses.includes(elementClass.value))
          if (! currentPadding) {
            currentPadding = {property: 'PaddingRight', value: 'PADDING_RIGHT_NONE', touched: false}
            this.addToArray(this.module, [currentPadding], this.classes, this.device, {}, true, this.parentModule)
          }
          return currentPadding.value
        },

        set: _.debounce(function (value) {
          let currentPadding = this.elementClasses(this.classes)[this.device].find(elementClass => this.rightPaddingClasses.includes(elementClass.value))
          value = {property: 'PaddingRight', value: value, touched: currentPadding.touched}
          this.addToArray(this.module, [value], this.classes, this.device, {}, true, this.parentModule)
        }, 250)
      },
    },
  })
</script>
